import React from 'react';
import { bool } from 'prop-types';

import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { Bold, Success } from '../../../utility-components';
import { formatPrice, formattedReward } from '../../../../utils/promo-presentation-utils';
import './PromoProgressMessage.scss';

export const PromoProgressMessage = ({ isInPromoDrawer }) => {
  const {
    minPurchaseQuantity,
    minPurchaseAmount,
    rewardAmountPerItem,
    rewardPercent,
    rewardAmountPerOrder,
    isBmsm,
    isMsb,
    rewardTiers,
  } = usePromoModel();
  const { promoCartQuantity, promoCartValue, isPromoAchieved, currentPromoTier } = usePromoCart();

  const isPromoCartEmpty = !promoCartQuantity;
  const amountLeftToQualify = Math.max(0, minPurchaseAmount - promoCartValue);
  const quantityLeftToQualify = Math.max(0, minPurchaseQuantity - promoCartQuantity);
  const toQualify = minPurchaseQuantity ? quantityLeftToQualify : formatPrice(amountLeftToQualify, true);

  let formattedRewardText = '';
  let lastSuccessfulTierRewardText = '';
  if (isMsb) {
    if (rewardAmountPerOrder) formattedRewardText = `save ${formatPrice(rewardAmountPerOrder, true)} `;
    else if (rewardPercent) formattedRewardText = `${rewardPercent}% off `;
    else formattedRewardText = `save ${formatPrice(rewardAmountPerItem * promoCartQuantity, true)} `;
  }

  if (isBmsm) {
    if (currentPromoTier > 0) {
      const lastSuccessfulTier = isPromoAchieved ? currentPromoTier : currentPromoTier - 1;
      lastSuccessfulTierRewardText = formattedReward(rewardTiers[lastSuccessfulTier], true);
    }
    formattedRewardText = formattedReward({ rewardAmountPerOrder, rewardPercent }, true);
  }

  return (
    <div className="promo-progress-message">
      {isPromoAchieved && (
        <>
          {/* Big success message */}
          {(isBmsm && isInPromoDrawer) && (
            <Bold className="u__large">Success!</Bold>
          )}

          {/* Amount saved success message */}
          <Bold>
            {isMsb && (
              <>
                <Success>Success!</Success> You {rewardPercent ? 'get ' : ''}
                <Success>{formattedRewardText}</Success>
                <span className="promo-progress-message__large-screen-text">
                  {!rewardPercent ? 'on ' : ''}this purchase
                </span>
              </>
            )}

            {isBmsm && (
              <span className="promo-progress-message__success-check">
                <Success>You Save {formattedRewardText} </Success>on this purchase
              </span>
            )}
          </Bold>
        </>
      )}

      {!isPromoAchieved && (
        <>
          {isMsb && (
            <Bold>Add<Success> {toQualify}{isPromoCartEmpty ? '' : ' More'}</Success> to Qualify</Bold>
          )}

          {isBmsm && (
            <>
              {lastSuccessfulTierRewardText && (
                <Bold className="promo-progress-message__success-check">
                  <Success>You Save {lastSuccessfulTierRewardText} Off </Success>Your Eligible Items
                </Bold>
              )}

              {/* BMSM 1 && BMSM 2 */}
              {minPurchaseQuantity ? (
                <>
                  {isPromoCartEmpty
                    ? (
                      <Bold>Add {toQualify} to Save <Success>{formattedRewardText}</Success></Bold>
                    )
                    : (
                      <Bold>
                        Add<Success> {toQualify} More </Success>to Save <Success>{formattedRewardText}</Success>
                      </Bold>
                    )}
                </>
              ) : null}

              {/* BMSM 4 && BMSM 5 */}
              {minPurchaseAmount ? (
                <>
                  {isPromoCartEmpty
                    ? (
                      <Bold>
                        <Success>Spend {toQualify} </Success>to Save<Success> {formattedRewardText}</Success>
                      </Bold>
                    )
                    : (
                      <Bold>
                        Spend<Success> {toQualify} More </Success>to Save<Success> {formattedRewardText}</Success>
                      </Bold>
                    )}
                </>
              ) : null}
            </>
          )}
        </>
      )}
    </div>
  );
};

PromoProgressMessage.displayName = 'PromoProgressMessage';

PromoProgressMessage.propTypes = {
  isInPromoDrawer: bool,
};

PromoProgressMessage.defaultProps = {
  isInPromoDrawer: false,
};
